import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Rest} from 'src/app/core/services/api/rest';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {EnvService} from '../../../app/services/env.service';

@Injectable()
export class ApiGraphboardsService extends Rest {
    constructor(
        protected http: HttpClient,
        protected translate: TranslateService,
        protected environment: EnvService
    ) {
        super(http, environment);
    }

    graphboards(dataParams: Array<any>): Observable<any> {
        dataParams[0]['lang'] = this.translate.currentLang;
        return this.apiGet(
            'graphboards',
            null,
            dataParams,
            ['@fromObject']
        );
    }

    graphboard(urlParams: Array<string>): Observable<any> {
        return this.apiGet(
            'graphboard',
            urlParams,
            null,
            null
        );
    }

    reportGraphboard<T, U>(urlParams: Array<string>, dataParams: any): Observable<any> {
        return this.apiGet(
            'report/graphboard',
            urlParams,
            dataParams,
            ['parts', 'language']
        );
    }

    reportEmail(dataParams: Array<any>): Observable<any> {
        return this.apiGet(
            'email/report',
            null,
            dataParams,
            ['emailTo', 'subject', 'message', 'pdfLink', 'name', 'origin', 'lang']
        );
    }

    postGraphboard(data): Observable<any> {
        return this.apiPost(
            'graphboard',
            null,
            data
        );
    }

    deleteGraphBoards(idList: string[]): Observable<any> {
        return this.apiPost(
            'graphboards/delete',
            null,
            {idList: idList}
        );
    }

    putGraphboard(urlParams: [string], item: any): Observable<any> {
        return this.apiPut(
            'graphboard',
            urlParams,
            item
        );
    }

    deleteGraphboard(urlParams: [string]): Observable<any> {
        return this.apiDelete(
            'graphboard',
            urlParams
        );
    }
}
